import { Component, OnInit, Input, OnChanges, SimpleChanges,ViewChild,Output,EventEmitter, ViewChildren, QueryList } from '@angular/core';
import { ConfigService } from '../../config-builder/service/config.service';
import { ViewReportComponent } from '../view-report/view-report.component';
import { ViewDrillReportComponent } from '../view-drill-report/view-drill-report.component';
import { LargeReportComponent } from '../large-report/large-report.component';

@Component({
  selector: 'app-report-manager',
  templateUrl: './report-manager.component.html',
  styleUrls: ['./report-manager.component.css']
})
export class ReportManagerComponent implements OnInit {
	@ViewChildren(ViewReportComponent) viewReports: QueryList<any>;
	@ViewChildren(ViewDrillReportComponent) viewDrillReports: QueryList<any>;
	@ViewChildren(LargeReportComponent) largeReports: QueryList<any>;

	@Input() report_id = -1;
	@Input() hidden_filter_object?: any = {};
	@Input() visible_filter_object?: any = {};
	@Input() refresh_timer?: any = -1;
	@Input() pause_refresh_timer?: any = true;
	@Input() group_child_report?:boolean = false;
	@Input() style_conf:any = {}
	@Output() ext_btn_event: EventEmitter<any> = new EventEmitter<any>();

	report_data:any = {}
	report_download = ''
	has_report = false
	constructor(
		private _configService:ConfigService
	) { }

	ngOnInit() {
	}
	ngOnChanges(changes:SimpleChanges) {
		if(this.report_id != -1){
			this.has_report = false
			this.get_report_data()
		}
	}

	refresh_reports(){
        this.viewDrillReports.forEach(comp => {
            if (comp) {
                comp.refresh_report_data();
            }
        });
        this.viewReports.forEach(comp => {
            if (comp ) {
                comp.refresh_report_data();
            }
        });
        this.largeReports.forEach(comp => {
            if (comp) {
                comp.refresh_job_status();
            }
        });
	}

	get_report_data(){
		this._configService.get_report_by_id({'id':this.report_id}).subscribe(res => {
			if(res.errCode == 0){
				this.report_data = res.data
				this.report_download = res.data['param_def']['report_download']?res.data['param_def']['report_download']:'direct'
				this.has_report = true
			}
		})
	}


	ext_btn_event_handler(event){
		this.ext_btn_event.emit(event);
	}
}
